"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SDTFOverviewData_overview;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDTFOverviewData = void 0;
const sdk_sdtf_primitives_1 = require("@shapediver/sdk.sdtf-primitives");
const AbstractTreeNodeData_1 = require("../AbstractTreeNodeData");
class SDTFOverviewData extends AbstractTreeNodeData_1.AbstractTreeNodeData {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(overview, id, version) {
        super(id, version);
        // #region Properties (1)
        _SDTFOverviewData_overview.set(this, {});
        __classPrivateFieldSet(this, _SDTFOverviewData_overview, overview, "f");
    }
    // #endregion Constructors (1)
    // #region Public Accessors (1)
    get overview() {
        return __classPrivateFieldGet(this, _SDTFOverviewData_overview, "f");
    }
    // #endregion Public Accessors (1)
    // #region Public Methods (1)
    /**
     * Clones the scene graph data.
     */
    clone() {
        return new SDTFOverviewData(__classPrivateFieldGet(this, _SDTFOverviewData_overview, "f"), this.id, this.version);
    }
    merge(data) {
        for (let overviewKey in data.overview) {
            for (let i = 0; i < data.overview[overviewKey].length; i++) {
                const dataToCopy = data.overview[overviewKey][i];
                const existingEntries = this.overview[overviewKey]
                    ? this.overview[overviewKey].filter((o) => o.typeHint === dataToCopy.typeHint)
                    : [];
                if (this.overview[overviewKey] && existingEntries.length > 0) {
                    const entry = existingEntries[0];
                    entry.count++;
                    if (sdk_sdtf_primitives_1.SdtfPrimitiveTypeGuard.isStringType(dataToCopy.typeHint)) {
                        // combine the countForValue
                        for (let i = 0; i < dataToCopy.values.length; i++) {
                            const value = dataToCopy.values[i];
                            // check if the the entry already has the value
                            const entryIndex = entry.values.indexOf(value);
                            if (entryIndex !== -1) {
                                entry.countForValue[entryIndex] +=
                                    dataToCopy.countForValue[i];
                            }
                            else {
                                entry.values.push(value);
                                entry.countForValue.push(dataToCopy.countForValue[i]);
                            }
                        }
                    }
                    if (sdk_sdtf_primitives_1.SdtfPrimitiveTypeGuard.isNumberType(dataToCopy.typeHint)) {
                        entry.min = Math.min(dataToCopy.min, entry.min);
                        entry.max = Math.max(dataToCopy.max, entry.max);
                    }
                }
                else if (this.overview[overviewKey]) {
                    this.overview[overviewKey].push({
                        typeHint: dataToCopy.typeHint,
                        count: dataToCopy.count,
                        values: dataToCopy.values
                            ? [...dataToCopy.values]
                            : dataToCopy.values,
                        countForValue: dataToCopy.countForValue
                            ? [...dataToCopy.countForValue]
                            : dataToCopy.countForValue,
                        min: dataToCopy.min,
                        max: dataToCopy.max,
                    });
                }
                else {
                    this.overview[overviewKey] = [
                        {
                            typeHint: dataToCopy.typeHint,
                            count: dataToCopy.count,
                            values: dataToCopy.values
                                ? [...dataToCopy.values]
                                : dataToCopy.values,
                            countForValue: dataToCopy.countForValue
                                ? [...dataToCopy.countForValue]
                                : dataToCopy.countForValue,
                            min: dataToCopy.min,
                            max: dataToCopy.max,
                        },
                    ];
                }
            }
        }
    }
}
exports.SDTFOverviewData = SDTFOverviewData;
_SDTFOverviewData_overview = new WeakMap();
//# sourceMappingURL=SDTFOverviewData.js.map